import { SchemaOf, object } from 'yup';
import { stringSchema, selectSchema } from 'Common/Validation/BaseSchemas';
import { AssetCategoryModels } from 'Models';

export const CategorySchema: SchemaOf<AssetCategoryModels.AddAssetCategory> = object({
	name: stringSchema('Name'),
	assetTypeId: selectSchema('Asset Type', 1),
});
